import 
{
    SPINNER_ON,
    SPINNER_OFF,
    DESCARGAS_BASEUNIVERSOPROSPECTOSSECTORCLIENTE,
    DESCARGAS_NOMBREBASEUNIVERSOPROSPECTOSSECTORCLIENTE,
    DESCARGAS_ERROR
}
from '../../types';

export default (state, action) => {
    switch(action.type){
        case SPINNER_ON:
            return{
                ...state,
                loadingSpinner: true
            }

        case SPINNER_OFF:
            return{
                ...state,
                loadingSpinner: false
            }

        case DESCARGAS_NOMBREBASEUNIVERSOPROSPECTOSSECTORCLIENTE:
        return{
            ...state,
            nombreBaseUniversoProspectosSectorCliente: action.payload
        }
        
        case DESCARGAS_BASEUNIVERSOPROSPECTOSSECTORCLIENTE:
        return{
            ...state,
            baseUniversoProspectosSectorCliente: action.payload
        }

        case DESCARGAS_ERROR:
            return{
                ...state,
                baseUniversoProspectosSectorCliente: [],
                nombreBaseUniversoProspectosSectorCliente: [],
                mensaje: null,
                loadingSpinner: null
            }
        default:
            return state;
    }
}